































import { Component, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { ReferralStats } from '@/api/model/referral-stats'
import { InputSelectOption } from '@/helpers/options'
import { namespace } from 'vuex-class'
const referrals = namespace('referrals')

@Component
export default class PipelineFilters extends Vue {
    @referrals.Getter('selectablePipelines') readonly pipelines!: Pipeline[]
    @referrals.State readonly pipelineFilter!: string
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.Action applyPipelineFilter: ({ id: string }) => Promise<void>

    onSelectedPipelineChanged(id: string|null): void {
        if (this.pipelineFilter && this.pipelineFilter === id) {
            return
        }

        this.applyPipelineFilter({
            id,
        })
    }

    get availablePipelines(): InputSelectOption[] {
        return [
            {
                label: this.$t('pipelineFilters.pipeline.all').toString(),
                value: null,
            },
            ...this.pipelines.map(pipeline => ({
                label: pipeline.name,
                value: pipeline.id,
            })),
        ]
    }

    getCount(id: string): number {
        return this.referralStats.countForPipeline(id)
    }

    getPipeline(id: string): Pipeline {
        return this.pipelines.find(v => v.id === id)
    }

    isExternalPipeline(id: string): boolean {
        if (!id) {
            return false
        }

        return this.getPipeline(id).isExternal(this.$currentCompany)
    }

    canViewPotentialOrderValue(id: string): boolean {
        if (!id) {
            return this.pipelines.findIndex(p => p.canViewPotentialOrderValue(this.$currentUser)) >= 0
        }

        return this.getPipeline(id).canViewPotentialOrderValue(this.$currentUser)
    }

    getPotentialOrderValue(id: string): number {
        if (!id) {
            let potentialOrderValue = 0
            this.pipelines.forEach(p => {
                potentialOrderValue += this.getPotentialOrderValue(p.id)
            })

            return potentialOrderValue
        }

        return this.referralStats.potentialOrderValueForPipeline(id)
    }
}
